module.exports = __webpack_public_path__ + "teqbahn-assets/media/4.4f5c3ee1.jpg";